import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  Form,
  Modal,
  Row,
  Overlay,
  Popover,
} from "react-bootstrap";
import ReactSelect from "react-select";
import Flatpickr from "react-flatpickr";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllOrgsData, selectAllOrgs, } from "../../redux/actions/getAllOrgsAction";
import { fetchCityData, selectCity } from "../../redux/actions/citiesAction";

import { customStyles } from "../../selectStyles";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import { useParams } from "react-router-dom";
import moment from "moment";
import toast from "react-hot-toast";
import axios from "../../API/axios";

const AddCertificate = ({ getUserCv, userDataId, showCertificate, handleCloseCertification }) => {
  const targetRef = useRef(null);

  const sessionId = localStorage.getItem("sessionId");
  const userType = localStorage.getItem("userType");
  const { CandidateId } = useParams();

  const [newEducation, setNewEducation] = useState("");
  const [showTooltip, setShowTooltip] = useState(false);
  const [certificateName, setCertificateName] = useState("");
  const [recognition, setRecognition] = useState("");
  const [credentialId, setCredentialId] = useState("");
  const [Description, setDescription] = useState("");
  const [IssueDate, setIssueDate] = useState("");
  const [ExpiredDate, setExpiredDate] = useState("");
  const [InsName, setInsName] = useState("");
  const [display, setDisplay] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisplay(true)
    const body = {
      "sessionId": sessionId,
      "userDataId": userDataId,
      "userType": userType,
      "instnCnddtID": CandidateId === "Candidate" ? null : CandidateId,
      "issuingOrgType": getallorgsId === '' ? neworgId : getallorgsId,
      "orgID": orgType === '' ? neworgType : orgType,
      "name": certificateName,
      "recognition": recognition,
      "credentialId": credentialId,
      "description": Description,
      "cityId": citySearch,
      "issueDate": moment(IssueDate).format("YYYY-MM-DD"),
      "isExpirable": isChecked,
      "expirationDate": ExpiredDate === '' ? null : moment(ExpiredDate).format("YYYY-MM-DD")
    }
    console.log("body", body);
    if (
      certificateName === '' ||
      (getallorgsId === '' && neworgId === '') ||
      (orgType === '' && neworgType === '') ||
      recognition === '' ||
      credentialId === '' ||
      // citySearch === '' ||
      IssueDate === ''
    ) {
      toast.error('Please fill all the required fields');
    } else {
      try {
        const res = await axios.post("/Resume/AddCertification", body);
        toast.success(res.data.message);
        handleCloseCertification();
        getUserCv();
        setOrgType("");
        setRecognition("");
        setCitySearch("");
        setDescription("");
        setOrgType("");
        setCertificateName("");
        setInsName("");
        setExpiredDate(null);
        setIssueDate(null);
        setCredentialId("");
        setDisplay(false)
      } catch (error) {
        if (error.response && error.response.status === 404) {
          toast.warning(error.response.data.message);
        } else {
          toast.error(error.response?.data?.message || "An error occurred");
        }
      }
    }
  }

  //   Create New Certificate
  const [showCreateCertification, setShowCreateCertification] = useState(false);
  const handleOpenCreateCertification = () => setShowCreateCertification(true);
  const handleCloseCreateCertification = () =>
    setShowCreateCertification(false);

  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const dispatch = useDispatch();

  //   Get organization
  const [getallorgsId, setGetAllOrgsId] = useState("");
  const [orgType, setOrgType] = useState("");
  const { getallorgsList, selectedgetallId } = useSelector(
    (state) => state.getallorgs
  );
  useEffect(() => {
    dispatch(fetchAllOrgsData());
  }, [dispatch]);
  const handleOrganization = (selectedOption) => {
    if (selectedOption) {
      // dispatch(selectAllOrgs(selectedOption.value));
      setGetAllOrgsId(selectedOption.value);
      setOrgType(selectedOption.tagId)
    }
  };

  //   Get City
  const [citySearch, setCitySearch] = useState(null);
  const { cityList, selectedcityId } = useSelector((state) => state.cities);
  useEffect(() => {
    dispatch(fetchCityData());
  }, [dispatch]);
  const handleCity = (selectedOption) => {
    if (selectedOption) {
      // dispatch(selectCity(selectedOption.value));
      setCitySearch(selectedOption.value);
    }
  };

  const toggleTooltip = () => {
    console.log("Toggling Tooltip");
    setShowTooltip((prev) => !prev);
  };
  const [fileName, setFileName] = useState(""); // State to store selected filename
  const handleFileChange = (event) => {
    const file = event.target.files[0]; // Get the selected file
    if (file) {
      setFileName(file.name); // Set the filename in state
    }
  };
  const [OrganizationName, setOrganizationName] = useState("");
  const [orgCity, setOrgCity] = useState(null);
  const [neworgType, setneworgType] = useState('');
  const [neworgId, setneworgId] = useState('');
  const handleCitySelect1 = (selectedOption) => {
    if (selectedOption) {
      setOrgCity(selectedOption.value);
    }
  };
  const handleSaveInstitution = async () => {
    const formData = new FormData();
    formData.append("orgName", OrganizationName);
    formData.append("OrgType", "UnRegdGeneralOrg");
    formData.append("CityID", orgCity);
    formData.append("OrgLogo", fileName);
    formData.append("sessionId", sessionId);
    console.log("formData", formData);

    try {
      const res = await axios.post("/CandidateData/AddGnrlOrgData", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("hdhdhjhad", res);
      // setGenOrgInstId(res.data.responseData);
      setneworgType(res.data.responseData.value)
      setneworgId(res.data.responseData.id)
      toast.success(res.data.message);
      setShowTooltip(false);
      setOrganizationName("");
      setOrgCity(null);
      setFileName("");
    } catch (error) {
      if (error.response && error.response.status === 404) {
        toast.warning(error.response.data.message);
      } else {
        toast.error(error.response?.data?.message || "An error occurred");
      }
    }
  };


  return (
    <>
      <Modal
        show={showCertificate}
        onHide={handleCloseCertification}
        centered
        size="lg"
      >
        <Modal.Header >
          <Modal.Title>Add Certificate</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleCloseCertification} />
        </Modal.Header>
        <Modal.Body className="settings">
          <Row>
            {/* Certificate Name */}
            <Col md={6}>
              <div className="post-form-group mb-0">
                <label htmlFor="certificateName">
                  Certificate Name{" "}
                  <span style={{ color: "red" }} className="ms-2">
                    *
                  </span>
                </label>
                <input type="text" placeholder="Enter certificate name"
                  value={certificateName}
                  onChange={(e) => {
                    setCertificateName(e.target.value)
                  }}
                />
                {display && !certificateName ? (
                  <span className="error_msg_lbl">Add Certification Name </span>
                ) : null}
              </div>

            </Col>

            {/* Organization */}
            <Col md={6} className="org-styles">
              <Form.Group controlId="organization">
                <Form.Label className="class-type">
                  Organization
                  <span style={{ color: "red" }} className="ms-2">
                    *
                  </span>
                </Form.Label>
                {InsName !== "" ? (
                  <div>
                    <input
                      type="text"
                      value={InsName}
                      placeholder="Enter Org name"
                      className="mb-2 form-control"
                      disabled
                    />
                  </div>
                ) : (
                  <div className="form-group">
                    <ReactSelect
                      options={getallorgsList}
                      onChange={handleOrganization}
                      value={
                        getallorgsList.find(
                          (option) => option.value === getallorgsId
                        ) || null
                      }
                      placeholder="Select Organization"
                      classNamePrefix="react-select"
                      className="form-control"
                      styles={customStyles}
                    />
                  </div>
                )}
              </Form.Group>
              <a
                href="#"
                ref={targetRef}
                onClick={(e) => {
                  e.preventDefault();
                  toggleTooltip();
                }}
                className="createModal"
              // isDisabled={!selectedIndustryId} // Disable until industry is selected
              >
                Create New
              </a>
              <Overlay
                target={targetRef.current}
                show={showTooltip}
                placement="right"
                rootClose
                container={document.querySelector(".modal")}
                onHide={() => setShowTooltip(false)} // Close when clicking outside
              >
                <Popover id="popover-basic">
                  <Popover.Header as="h3" className="Dark-Body-Card-group">Create Organization</Popover.Header>
                  <Popover.Body className="Dark-Body-Card-group">
                    <Form>
                      <div>
                        <label className="mb-1 Text-mb-Create">Org name</label>
                        <input
                          type="text"
                          value={OrganizationName}
                          // onChange={(e) => setOrganizationName(e.target.value)}
                          onChange={(e) => {
                            setOrganizationName(e.target.value);
                            setInsName(e.target.value);
                          }}
                          placeholder="Enter Org name"
                          className="mb-2 form-control Dark-Input-from-group"
                        />
                      </div>
                      <div>
                        <label className="mb-1 Text-mb-Create">City</label>
                        <ReactSelect
                          options={cityList}
                          onChange={handleCitySelect1}
                          value={
                            cityList.find(
                              (option) => option.value === orgCity
                            ) || null
                          }
                          placeholder="Select City"
                          classNamePrefix="react-select"
                          className="form-control Dark-Input-from-group"
                          styles={customStyles}
                        />
                      </div>
                      <div className=" mt-2 mb-2 Text-mb-Create">
                        <label className="mb-1">Org Logo</label>
                        <input
                          type="file"
                          id="lastName"
                          className="form-control Dark-Input-from-group"
                          placeholder=""
                          onChange={handleFileChange}
                        />
                      </div>
                      <div className="d-flex justify-content-end">
                        <Button
                          variant="primary"
                          size="sm"
                          onClick={() => {
                            handleSaveInstitution()
                          }}
                          className="me-2"
                        >
                          Save
                        </Button>
                        <Button
                          variant="secondary"
                          size="sm"
                          onClick={() => setShowTooltip(false)}
                        >
                          Cancel
                        </Button>
                      </div>
                    </Form>
                  </Popover.Body>
                </Popover>
              </Overlay>
            </Col>

            {/* Recognition */}
            <Col md={6}>
              <div className="post-form-group">
                <label htmlFor="recognition">
                  Recognition{" "}
                  <span style={{ color: "red" }} className="ms-2">
                    *
                  </span>
                </label>
                <input type="text" placeholder="Enter recognition"
                  value={recognition}
                  onChange={(e) => {
                    setRecognition(e.target.value)
                  }}
                />
                {display && !recognition ? (
                  <span className="error_msg_lbl">Add Recognition </span>
                ) : null}
              </div>
            </Col>

            {/* Credential ID */}
            <Col md={6}>
              <div className="post-form-group">
                <label htmlFor="credentialId">
                  Credential Id{" "}
                  <span style={{ color: "red" }} className="ms-2">
                    *
                  </span>
                </label>
                <input type="text" placeholder="Enter credential ID"
                  value={credentialId}
                  onChange={(e) => {
                    setCredentialId(e.target.value)
                  }}
                />
                {display && !credentialId ? (
                  <span className="error_msg_lbl">Add Credential Id </span>
                ) : null}
              </div>
            </Col>

            {/* City */}
            <Col md={6}>
              <Form.Group controlId="city">
                <Form.Label className="class-type">
                  City
                  {/* <span style={{ color: "red" }} className="ms-2">
                    *
                  </span> */}
                </Form.Label>
                <div className="post-form-group">
                  <ReactSelect
                    options={cityList}
                    onChange={handleCity}
                    value={
                      cityList.find(
                        (option) => option.value === citySearch
                      ) || null
                    }
                    placeholder="Select City"
                    classNamePrefix="react-select"
                    className="form-control"
                    styles={customStyles}
                  />
                  {/* {display && !citySearch ? (
                    <span className="error_msg_lbl">Select City </span>
                  ) : null} */}
                </div>
              </Form.Group>
            </Col>

            {/* Description */}
            <Col md={6}>
              <div className="post-form-group">
                <label htmlFor="description">
                  Description{" "}
                  {/* <span style={{ color: "red" }} className="ms-2">
                    *
                  </span> */}
                </label>
                <input type="text" placeholder="Enter description"
                  value={Description}
                  onChange={(e) => {
                    setDescription(e.target.value)
                  }} />
              </div>
            </Col>

            {/* Issue Date */}
            <Col md={6}>
              <div className="w-100 post-form-group">
                <label htmlFor="issueDate">
                  Issue Date
                  <span style={{ color: "red" }} className="ms-2">*</span>
                </label>
                <Flatpickr className="form-control Dark-Input-from-group" id="issueDate"
                  value={IssueDate}
                  onChange={(date) => setIssueDate(date[0])}
                />
                {display && !IssueDate ? (
                  <span className="error_msg_lbl">Select Issue Date </span>
                ) : null}
              </div>
            </Col>

            <Col md={6}>
              <div className="mt-4">
                <input
                  type="checkbox"
                  style={{ width: "40px" }}
                  checked={isChecked} // Bind the checkbox to state
                  onChange={handleCheckboxChange}
                //   id={`check-${item.id}`}
                //   id={`check-${item.id}`}
                //   checked={selectedWorkLevelList.includes(item.id)}
                //   onChange={() => setPresent(true)}
                />
                <label htmlFor="about">IsExpirable</label>
              </div>
            </Col>

            {/* Expiration Date */}
            {isChecked && (
              <Col md={6}>
                <div className="col-md-6 mt-2 w-100">
                  <label htmlFor="expirationDate">
                    Expiration Date
                    {/* <span className="text-danger ms-2">*</span> */}
                  </label>
                  <Flatpickr className="form-control Dark-Input-from-group" id="expirationDate"
                    value={ExpiredDate}
                    onChange={(date) => setExpiredDate(date[0])} />
                </div>
              </Col>
            )}

            {/* Checkbox */}
          </Row>

          {/* Submit and Close Buttons */}
          <div className="add-class-submit-button mt-4 d-flex justify-content-center">
            <div className="khojPrimaryBtn ms-3">
              <a href="#/" className="" onClick={(e) => { handleSubmit(e) }}>
                Submit
              </a>
            </div>
          </div>
        </Modal.Body>
      </Modal >

    </>
  );
};

export default AddCertificate;
